import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { FooterAction } from "@/components/organisms/FooterAction";
import { useButtonObserver } from "@/hooks/useButtonObserver";

export const SectionAction = () => {
  const isDisabled = useButtonObserver("btn-payment-vcd");
  const { isPaymentSuscribed } = useSelector((state) => state.global);

  const handleClick = () => {
    const element = document.getElementsByClassName("btn-payment-vcd");
    element[0].click();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter' && isPaymentSuscribed) {
        event.preventDefault();
        handleClick();
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isPaymentSuscribed]);

  return (
    <FooterAction
      textButton="Pagar"
      disabled={isDisabled}
      onHandleClick={handleClick}
    />
  );
};
